/* MapData.js */

"use strict";
/* global Slick */
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
// const $ = require("jquery");
const {
    Control: {
        Boolean: {InputCheckbox},
    },
} = uiCore;

const createRoleMethodsWithContext = require("./MapDataUtility/roles");
const createManufacturerMethodsWithContext = require("./MapDataUtility/manufacturers");
const createTypesMethodsWithContext = require("./MapDataUtility/types");
const createPlatformMethodsWithContext = require("./MapDataUtility/platforms");

const EventEmitter = require("events").EventEmitter;

class MapDataTab extends EventEmitter {
    constructor(dataSyncConfigEntity, muf, uiUtils, metadata) {
        super();
        this._dataSyncConfigEntity = dataSyncConfigEntity;
        this._metaData = metadata;
        this._muf = muf;
        this._uiUtils = uiUtils;
        this._createNoConnectionPlaceholder();
        this._tableOptions = {
            editable: true,
            enableCellNavigation: true,
            enableAsyncPostRender: true,
            forceFitColumns: true,
            autoHeight: false,
            autoEdit: true,
            resizable: false,
            rowHeight: 40,
        };
        this._onBeforeEditCell = this._onBeforeEditCell.bind(this);
        createRoleMethodsWithContext(this);
        createManufacturerMethodsWithContext(this);
        // this.createTypesMethodsWithContext = createTypesMethodsWithContext.bind(this);
        // this.createTypesMethodsWithContext(this);
        createTypesMethodsWithContext(this);
        createPlatformMethodsWithContext(this);
        this.initializeComponents();
        this._documentClickHandler = this._documentClickHandler.bind(this);
        this.registerListeners();
    }

    whenReady() {
        const prom = [];

        return Promise.all(prom).then(() => {
            // console.log(values);
            // this._metaData = values[0].summary.metadata;
            this._vendorOptions = this.createGluVendorOptions();
            this._gluDeviceTypeOptions = this.createGluDeviceTypeOptions();
            this._nbDeviceRoleOptions = this.createNbDeviceRolesOptions();
            this._nbManufacturersOptions = this.createNbManufacturersOptions();
            this._nbDeviceTypeOptions = this.createNbDeviceTypeOptions();
            this._nbPlatformOptions = this.createNbPlatformOptions();
        });
    }

    // getMetaData() {
    //     // const workTarget = {};
    //     const workInput = {
    //         dataProvider: "netBox",
    //         dataProviderProduct: "cmdb",
    //     };
    //     return this._dataSyncConfigEntity.runMetaDataWork(workInput);
    // }

    initializeComponents() {
        this._container = document.createElement("div");
        this._container.classList.add("map-data-container");

        this._deviceRoleContainer = document.createElement("div");
        this._deviceRoleContainer.classList.add("device-roles", "collapsable");
        this._drHeading = document.createElement("h3");
        this._drHeading.classList.add("collapse");
        this._drHeading.innerHTML = "Device Roles";
        this._drCreateUnmappedCheckbox = new InputCheckbox({
            label: "Auto-create missing Device Roles in NetBox",
            labelShown: true,
            value: false,
            darkTheme: true,
        });

        this._deviceTypeContainer = document.createElement("div");
        this._deviceTypeContainer.classList.add("device-type", "collapsable");
        this._dtHeading = document.createElement("h3");
        this._dtHeading.classList.add("collapse");
        this._dtHeading.innerHTML = "Device Types";
        this._dtCreateUnmappedCheckbox = new InputCheckbox({
            label: "Auto-create missing Device Types in NetBox",
            labelShown: true,
            value: false,
            darkTheme: true,
        });

        this._manufacturersContainer = document.createElement("div");
        this._manufacturersContainer.classList.add("manufacturers", "collapsable");
        this._mHeading = document.createElement("h3");
        this._mHeading.classList.add("collapse");
        this._mHeading.innerHTML = "Manufacturers";
        this._mCreateUnmappedCheckbox = new InputCheckbox({
            label: "Auto-create missing Manufacturers in NetBox",
            labelShown: true,
            value: false,
            darkTheme: true,
        });

        this._platformsContainer = document.createElement("div");
        this._platformsContainer.classList.add("platforms", "collapsable");
        this._pHeading = document.createElement("h3");
        this._pHeading.classList.add("collapse");
        this._pHeading.innerHTML = "Platforms";
        this._pCreateUnmappedCheckbox = new InputCheckbox({
            label: "Auto-create missing Platforms in NetBox",
            labelShown: true,
            value: false,
            darkTheme: true,
        });

        this._getContent();
        // this._createRolesContent();
    }

    _getContent() {
        /* Roles content*/
        this._deviceRoleContainer.innerHTML = "";
        this._deviceRoleContainer.appendChild(this._drHeading);
        this._createRolesContent();
        /*Types*/
        this._deviceTypeContainer.innerHTML = "";
        this._deviceTypeContainer.appendChild(this._dtHeading);
        this._createTypesContent();
        /*Manufacturers*/
        this._manufacturersContainer.innerHTML = "";
        this._manufacturersContainer.appendChild(this._mHeading);
        this._createManufacturersContent();
        /*Platforms*/
        this._platformsContainer.innerHTML = "";
        this._platformsContainer.appendChild(this._pHeading);
        this._createPlatformsContent();

        this._container.appendChild(this._deviceRoleContainer);
        this._container.appendChild(this._deviceTypeContainer);
        this._container.appendChild(this._manufacturersContainer);
        this._container.appendChild(this._platformsContainer);
        this._container.appendChild(this._noConnectionEl);

        return this._container;
    }

    getMapDataContent() {
        const _tabMainContent = document.createElement("div");
        _tabMainContent.classList.add("content-main", "device-to-ci-linking");
        this._tabMainContent = _tabMainContent;

        _tabMainContent.appendChild(this._container);
        this._drCreateUnmappedCheckbox.setValue(this.getRoleCreateUnmapped());
        this._dtCreateUnmappedCheckbox.setValue(this.getTypeCreateUnmapped());
        this._mCreateUnmappedCheckbox.setValue(this.getManufacturersCreateUnmapped());
        this._pCreateUnmappedCheckbox.setValue(this.getPlatformsCreateUnmapped());
        return _tabMainContent;
    }

    shutdown() {
        const prom = [];
        this.unregisterListeners();
        this.unregisterRoleListeners();
        this.unregisterTypeListeners();
        this.unregisterManufacturerListeners();
        this.unregisterPlatformListeners();
        Promise.all(prom).then(() => {
            this._metaData = undefined;
            this._container = undefined;
            this._deviceRoleContainer = undefined;
            this._deviceTypeContainer = undefined;
            this._manufacturersContainer = undefined;
            this._platformsContainer = undefined;
        });
    }

    registerListeners() {
        document.addEventListener("click", this._documentClickHandler);
        this._container.addEventListener(
            "click",
            (this._onContainerClick = this._onContainerClick.bind(this))
        );
        this._container.addEventListener(
            "click",
            (this._deleteClickHandler = this._deleteClickHandler.bind(this))
        );
        this._dtCreateUnmappedCheckbox.on(
            "UserValue",
            (this._dtCreateUnmappedHandler = this._dtCreateUnmappedHandler.bind(this))
        );
        this._drCreateUnmappedCheckbox.on(
            "UserValue",
            (this._drCreateUnmappedHandler = this._drCreateUnmappedHandler.bind(this))
        );
        this._mCreateUnmappedCheckbox.on(
            "UserValue",
            (this._mCreateUnmappedHandler = this._mCreateUnmappedHandler.bind(this))
        );
        this._pCreateUnmappedCheckbox.on(
            "UserValue",
            (this._pCreateUnmappedHandler = this._pCreateUnmappedHandler.bind(this))
        );
    }

    unregisterListeners() {
        document.removeEventListener("click", this._documentClickHandler);
        this._container.removeEventListener("click", this._onContainerClick);
        this._container.removeEventListener("click", this._deleteClickHandler);
        this._dtCreateUnmappedCheckbox.removeAllListeners();
        this._drCreateUnmappedCheckbox.removeAllListeners();
        this._mCreateUnmappedCheckbox.removeAllListeners();
        this._pCreateUnmappedCheckbox.removeAllListeners();
    }

    /* Event handlers */

    _documentClickHandler(evt) {
        const activeTabEl = this._container.closest(".tab-content");
        if (!activeTabEl.classList.contains("show")) {
            return;
        }
        this._saveAndCloseEditCellAction(evt);
    }

    _onContainerClick(evt) {
        // console.log(evt.target);

        if (evt.target.classList.contains("collapse")) {
            const el = evt.target.closest(".collapsable");
            if (el.classList.contains("collapsed")) {
                el.classList.remove("collapsed");
            } else {
                el.classList.add("collapsed");
            }
        }
    }

    _saveAndCloseEditCellAction(e) {
        //do nothing if no active editors
        const slickTables = [
            this._slickManufacturersTable,
            this._slickPlatformsTable,
            this._slickRolesTable,
            this._slickTypesTable,
        ];
        const tablesWithActiveEditors = slickTables.filter(
            (table) => table && table.getEditorLock().isActive()
        );
        if (tablesWithActiveEditors.length === 0) {
            return false;
        }
        tablesWithActiveEditors.forEach((table) => {
            //get event bubbling path
            const path = e.path || e.composedPath();

            //check if click was outside of current editing cell
            let outsideClick = true;
            _.each(path, (element) => {
                const elHasClass = (className) =>
                    element.classList && element.classList.contains(className);

                if (elHasClass("slick-cell")) {
                    const cellHasActiveEditor = elHasClass("active") && elHasClass("editable");
                    outsideClick = !cellHasActiveEditor;
                    return false;
                }

                if (element.tagName === "SLICK-TABLE-CMDB") {
                    return false;
                }
            });

            if (outsideClick) {
                table.getEditorLock().commitCurrentEdit();
            }
        });
    }
    _onBeforeEditCell(e, args) {
        if (args.item.isUnavailable && args.column.field === "regex") {
            return false;
        }
        return true;
    }

    _deleteClickHandler(evt) {
        const target = evt.target.closest("base-icon-gl");
        // console.log(target);
        if (
            target &&
            target.getAttribute("role") === "button" &&
            target.dataset.action === "delete-role" &&
            target.dataset.uuid
        ) {
            this._deleteRole(target.dataset.uuid);
        } else if (
            target &&
            target.getAttribute("role") === "button" &&
            target.dataset.action === "delete-type" &&
            target.dataset.uuid
        ) {
            this._deleteType(target.dataset.uuid);
        } else if (
            target &&
            target.getAttribute("role") === "button" &&
            target.dataset.action === "delete-manufacturer" &&
            target.dataset.uuid
        ) {
            this._deleteManufacturer(target.dataset.uuid);
        } else if (
            target &&
            target.getAttribute("role") === "button" &&
            target.dataset.action === "delete-platform" &&
            target.dataset.uuid
        ) {
            this._deletePlatform(target.dataset.uuid);
        }
    }

    _dtCreateUnmappedHandler(val) {
        const dataSyncMapping = this._dataSyncConfigEntity.getDataSyncMappings() || {};
        _.set(dataSyncMapping, "modelMapping.deviceTypes.createUnmapped", val);
        this._dataSyncConfigEntity.setDataSyncMappings(dataSyncMapping);
        this.emit("ValueChange");
    }

    _drCreateUnmappedHandler(val) {
        const dataSyncMapping = this._dataSyncConfigEntity.getDataSyncMappings() || {};
        _.set(dataSyncMapping, "modelMapping.deviceRoles.createUnmapped", val);
        this._dataSyncConfigEntity.setDataSyncMappings(dataSyncMapping);
        this.emit("ValueChange");
    }

    _mCreateUnmappedHandler(val) {
        const dataSyncMapping = this._dataSyncConfigEntity.getDataSyncMappings() || {};
        _.set(dataSyncMapping, "modelMapping.manufacturers.createUnmapped", val);
        this._dataSyncConfigEntity.setDataSyncMappings(dataSyncMapping);
        this.emit("ValueChange");
    }

    _pCreateUnmappedHandler(val) {
        const dataSyncMapping = this._dataSyncConfigEntity.getDataSyncMappings() || {};
        _.set(dataSyncMapping, "modelMapping.platforms.createUnmapped", val);
        this._dataSyncConfigEntity.setDataSyncMappings(dataSyncMapping);
        this.emit("ValueChange");
    }

    /* Render helpers */
    _showError(error) {
        if (_.get(error, "errorCode") !== "NoPendingUpdates") {
            if (!error.errorCode) {
                error.errorCode = "Err";
            }
            this._uiUtils.showMessageDialog({
                message: "An error occurred: " + this._uiUtils.errorCodeMapping(error),
                confirmButtonName: "OK",
            });
        }
    }

    _deleteConfirmation(msg) {
        const deleteMessage = msg || `Are you sure you want to delete the mapping?`;

        return this._uiUtils.showDeleteConfirmDialog({
            message: deleteMessage,
            confirmButtonName: "Confirm",
            cancelButtonName: "Cancel",
        });
    }

    _createNoDataPlaceholder() {
        const noDataPlaceholder = document.createElement("div");
        noDataPlaceholder.classList.add("no-data-placeholder");
        noDataPlaceholder.innerText = "No Mappings Available";
        return noDataPlaceholder;
    }

    _createNoConnectionPlaceholder() {
        this._noConnectionEl = this._createBanner(
            "Unable to connect to NetBox. Please verify configured connection details.",
            "no-cmdb-connection"
        );
    }
    _createBanner(msg, className) {
        const msgContainer = document.createElement("div");
        msgContainer.classList.add(className);
        const innerSpan = document.createElement("span");
        innerSpan.innerText = msg;

        msgContainer.appendChild(innerSpan);

        return msgContainer;
    }

    _toggleNoDataPlaceholder(state, container) {
        container.classList.toggle("empty", state);
    }
    _enableDisableAutoCreate(state, target) {
        if (state) {
            target.setValue(true);
        }
        target.setDisabled(state);
    }

    _displayInvalidVeil(err) {
        console.log(err);
        const error = {
            errorMsg: "Invalid values",
            errorCode: "Invalid Values",
        };
        return this._muf.hideDisplayed().then(() => {
            // this._logger.warn({error: err}, "InvalidValues");
            return this._muf.displayError(err || error);
        });
    }

    _connectionFailed() {
        this._noConnectionEl.classList.add("show");
        this._tabMainContent.classList.add("no-connection");
    }

    _connectionPassed() {
        this._noConnectionEl.classList.remove("show");
        this._tabMainContent.classList.remove("no-connection");
        this.whenReady().then(() => {
            this._resetValues();
        });
    }

    /* ----------------- */

    render() {
        this._renderRolesSlickGrid();
        this._renderManufacturersSlickGrid();
        this._renderTypesSlickGrid();
        this._renderPlatformsSlickGrid();
        this.validateAllMapData();
    }

    _getAvailableSortedValues(gluValues) {
        const vendorsList = Object.keys(gluValues);
        let allValues = [];
        const allGluValues = {};
        for (let i = 0; i < vendorsList.length; i++) {
            let vendorValues = gluValues[vendorsList[i]];
            vendorValues = Object.keys(vendorValues)
                .filter((val) => vendorValues[val])
                .sort();
            allGluValues[vendorsList[i]] = vendorValues;
            allValues = allValues.concat(vendorValues);
        }

        allGluValues["ALL"] = allValues.sort();
        return allGluValues;
    }

    validateMapData() {
        return (
            this._validateRoleData() &&
            this._validateManufacturersData() &&
            this._validateTypesData() &&
            this._validatePlatformsData()
        );
    }

    validateAllMapData() {
        this._validateRoleData();
        this._validateManufacturersData();
        this._validateTypesData();
        this._validatePlatformsData();
    }

    _resetValues() {
        this._resetManufacturersGrid();
        this._resetPlatformsGrid();
        this._resetRoleGrid();
        this._resetTypeGrid();
    }

    /* Mapping data getters */
    getSyncMappingModel(opt) {
        const dataSyncMapping = this._dataSyncConfigEntity.getDataSyncMappings() || {};
        if (!opt) {
            return dataSyncMapping.modelMapping;
        }
        let mapping;
        switch (opt) {
            case "deviceRoles":
                mapping = dataSyncMapping.modelMapping
                    ? dataSyncMapping.modelMapping.deviceRoles
                    : {};
                break;
            case "deviceTypes":
                mapping = dataSyncMapping.modelMapping
                    ? dataSyncMapping.modelMapping.deviceTypes
                    : {};
                break;
            case "manufacturers":
                mapping = dataSyncMapping.modelMapping
                    ? dataSyncMapping.modelMapping.manufacturers
                    : {};
                break;
            case "platforms":
                mapping = dataSyncMapping.modelMapping
                    ? dataSyncMapping.modelMapping.platforms
                    : {};
                break;
            default:
                mapping = dataSyncMapping.modelMapping;
        }

        return mapping;
    }

    getRoleData() {
        return this.getSyncMappingModel("deviceRoles");
    }

    getRoleMapping() {
        return (this.getRoleData() || {}).mapping;
    }

    getRoleCreateUnmapped() {
        return (this.getRoleData() || {}).createUnmapped;
    }

    getTypeData() {
        return this.getSyncMappingModel("deviceTypes");
    }

    getTypeMapping() {
        return (this.getTypeData() || {}).mapping;
    }

    getTypeCreateUnmapped() {
        return (this.getTypeData() || {}).createUnmapped;
    }

    getManufacturersData() {
        return this.getSyncMappingModel("manufacturers");
    }

    getManufacturersMapping() {
        return (this.getManufacturersData() || {}).mapping;
    }

    getManufacturersCreateUnmapped() {
        return (this.getManufacturersData() || {}).createUnmapped;
    }

    getPlatformsData() {
        return this.getSyncMappingModel("platforms");
    }

    getPlatformsMapping() {
        return (this.getPlatformsData() || {}).mapping;
    }

    getPlatformsCreateUnmapped() {
        return (this.getPlatformsData() || {}).createUnmapped;
    }

    /* Metadata getters */
    getGluMetaData() {
        return this._metaData && this._metaData.gluware ? this._metaData.gluware : {};
    }
    getGluVendors() {
        const gluData = this.getGluMetaData();
        return gluData.vendors ? gluData.vendors : {};
    }
    getGluDeviceTypes() {
        const gluData = this.getGluMetaData();
        return gluData.typeBases ? gluData.typeBases : {};
    }

    getGluSkus() {
        const gluData = this.getGluMetaData();
        return gluData.skus ? gluData.skus : {};
    }

    getGluPlatforms() {
        const gluData = this.getGluMetaData();
        return gluData.platforms ? gluData.platforms : {};
    }

    /*Netbox*/
    getNetBoxMetaData() {
        return this._metaData && this._metaData.netbox ? this._metaData.netbox : {};
    }

    getNbDeviceRoles() {
        const nbData = this.getNetBoxMetaData();
        return nbData.deviceRoles ? nbData.deviceRoles : [];
    }

    getNbDeviceTypes() {
        const nbData = this.getNetBoxMetaData();
        return nbData.deviceTypes ? nbData.deviceTypes : [];
    }

    getNbManufacturers() {
        const nbData = this.getNetBoxMetaData();
        return nbData.manufacturers ? nbData.manufacturers : [];
    }

    getNbPlatforms() {
        const nbData = this.getNetBoxMetaData();
        return nbData.platforms ? nbData.platforms : [];
    }

    /* Metadata getters end */

    /* Field Options creators */
    createGluVendorOptions() {
        const vendorsList = this.getGluVendors();
        return Object.keys(vendorsList).map((vendor) => {
            return {
                label: vendorsList[vendor],
                value: vendor,
            };
        });
    }

    createGluDeviceTypeOptions() {
        const typesList = this.getGluDeviceTypes();
        return Object.keys(typesList).map((type) => {
            return {
                label: typesList[type],
                value: type,
            };
        });
    }

    /*Netbox*/
    createNbDeviceRolesOptions() {
        const rolesList = this.getNbDeviceRoles();
        return rolesList.map((role) => {
            return {
                label: role.display,
                value: role.id,
            };
        });
    }

    createNbDeviceTypeOptions() {
        const typesList = this.getNbDeviceTypes();
        return typesList.map((type) => {
            return {
                label: type.display,
                value: type.id,
            };
        });
    }

    createNbManufacturersOptions() {
        const mfList = this.getNbManufacturers();
        return mfList.map((mf) => {
            return {
                label: mf.display,
                value: mf.id,
            };
        });
    }

    createNbPlatformOptions() {
        const pfList = this.getNbPlatforms();
        return pfList.map((pf) => {
            return {
                label: pf.display,
                value: pf.id,
            };
        });
    }

    /* Slick */

    _registerRowMovePlugin(grid, dataView) {
        const moveRowsPlugin = new Slick.RowMoveManager({
            cancelEditOnDrag: true,
        });
        // const sortingComparator = this._model.CustomFieldsEntity.getSortingComparator("order");

        moveRowsPlugin.onBeforeMoveRows.subscribe(function (e, {insertBefore, rows}) {
            rows = [...rows].sort();
            if (
                _.first(rows) === insertBefore ||
                _.last(rows) === insertBefore - 1
                // _.get(dataView.getItem(insertBefore), "inherited")
            ) {
                e.stopPropagation();
                return false;
            }
            return true;
        });
        moveRowsPlugin.onMoveRows.subscribe((e, args) => {
            let extractedRows = [],
                left,
                right;
            let rows = args.rows;
            let insertBefore = args.insertBefore;
            let data = dataView.getItems();
            left = data.slice(0, insertBefore);
            right = data.slice(insertBefore, data.length);

            rows.sort(function (a, b) {
                return a - b;
            });

            for (let i = 0; i < rows.length; i++) {
                extractedRows.push(data[rows[i]]);
            }

            rows.reverse();

            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];
                if (row < insertBefore) {
                    left.splice(row, 1);
                } else {
                    right.splice(row - insertBefore, 1);
                }
            }

            data = left.concat(extractedRows.concat(right));

            let selectedRows = [];
            for (let i = 0; i < rows.length; i++) {
                selectedRows.push(left.length + i);
            }
            dataView.setItems(data);

            grid.resetActiveCell();
            grid.setSelectedRows(selectedRows);
            grid.invalidate();
            grid.render();
            grid.resizeCanvas();

            const customEvent = new CustomEvent("RowOrderChanged", {});
            grid.getContainerNode().dispatchEvent(customEvent);
        });

        grid.registerPlugin(moveRowsPlugin);
    }

    setDataSyncEntity(ety) {
        this._dataSyncConfigEntity = ety;
    }
}

module.exports = MapDataTab;
